import React from "react";
import { ArrowRight } from "lucide-react";
import {
  Accordion, AccordionContent, AccordionItem, AccordionTrigger,
} from "@/components/ui/accordion";
import { FAQS } from "@/data/content";
import { Reveal, Overline } from "@/components/site/Reveal";
import { useLead } from "@/components/site/LeadContext";

export default function FAQ() {
  const { openLead } = useLead();
  return (
    <section className="relative bg-sand py-24 md:py-32" data-testid="faq-section">
      <div className="mx-auto max-w-3xl px-6 lg:px-8">
        <Reveal className="text-center">
          <Overline className="text-sun">Dúvidas frequentes</Overline>
          <h2 className="mt-4 font-display text-4xl font-extrabold uppercase leading-[1.04] tracking-tight text-brand-navy sm:text-5xl">
            Ainda com perguntas?
          </h2>
        </Reveal>

        <Reveal delay={0.08} className="mt-12">
          <Accordion type="single" collapsible className="space-y-3">
            {FAQS.map((item, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                className="overflow-hidden rounded-2xl border border-ocean-mid/15 bg-white px-5 data-[state=open]:border-ocean-mid/40"
                data-testid={`faq-item-${i}`}
              >
                <AccordionTrigger className="py-5 text-left font-display text-lg font-semibold text-brand-navy hover:no-underline">
                  {item.q}
                </AccordionTrigger>
                <AccordionContent className="pb-5 text-base leading-relaxed text-muted-foreground">
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>

        <Reveal delay={0.15} className="mt-12 flex justify-center">
          <button
            onClick={() => openLead("FAQ")}
            className="cta-sun animate-pulse-glow inline-flex w-full items-center justify-center gap-2 rounded-full px-8 py-5 text-base font-extrabold uppercase tracking-wide text-white shadow-2xl shadow-sun/30 sm:w-auto sm:text-lg"
            data-testid="faq-cta"
          >
            Quero meu ingresso
            <ArrowRight className="h-5 w-5" />
          </button>
        </Reveal>
      </div>
    </section>
  );
}
